import React from "react"
import types from "prop-types"
import clsx from "clsx"

const DEFAULT_CLASSES = "flex items-center justify-between px-4 pt-3 pb-5"

const TileFooter = ({ children, className = "" }) => (
  <div className={clsx(className, DEFAULT_CLASSES)}>
    {children}
  </div>
)

TileFooter.propTypes = {
  children: types.node.isRequired,
  className: types.string,
}

export default TileFooter
